import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaArrowLeft, FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4 relative overflow-hidden">
            {/* Background Elements */}
            <div className="absolute inset-0 bg-black/40 z-0"></div>
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl"></div>

            {/* Main Content */}
            <div className="relative z-10 w-full max-w-4xl">
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl border border-white/20 shadow-2xl overflow-hidden">
                    <div className="flex flex-col lg:flex-row">
                        {/* Left Side - Illustration */}
                        <div className="lg:w-1/2 w-full p-8 lg:p-12 flex items-center justify-center bg-gradient-to-br from-blue-500/10 to-purple-600/10">
                            <div className="text-center">
                                {/* Animated 404 */}
                                <div className="relative mb-8">
                                    <div className="text-9xl lg:text-10xl font-bold text-white/20">
                                        404
                                    </div>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <FaExclamationTriangle className="text-6xl lg:text-7xl text-yellow-400 animate-pulse" />
                                    </div>
                                </div>

                                {/* Floating Elements */}
                                <div className="flex justify-center gap-4 mt-8">
                                    <div className="w-4 h-4 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                                    <div className="w-4 h-4 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                    <div className="w-4 h-4 bg-pink-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }}></div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Content */}
                        <div className="lg:w-1/2 w-full p-8 lg:p-12 flex flex-col justify-center">
                            {/* Header */}
                            <div className="text-center lg:text-left mb-6">
                                <h1 className="text-3xl lg:text-4xl font-bold text-white mb-3">
                                    Page Not Found
                                </h1>
                                <p className="text-gray-300 text-lg leading-relaxed">
                                    Oops! The page you're looking for seems to have wandered off into the digital void.
                                </p>
                            </div>

                            {/* Error Details */}
                            <div className="bg-black/20 rounded-xl p-4 mb-8 border border-white/10">
                                <div className="flex items-center gap-3 text-yellow-400 mb-2">
                                    <FaExclamationTriangle />
                                    <span className="font-semibold">Error 404</span>
                                </div>
                                <p className="text-gray-300 text-sm">
                                    The requested URL was not found on this server. This might be due to:
                                </p>
                                <ul className="text-gray-400 text-sm mt-2 space-y-1 list-disc list-inside">
                                    <li>Typed the wrong address</li>
                                    <li>Page has been moved or deleted</li>
                                    <li>Temporary technical issues</li>
                                </ul>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 mb-8">
                                <Link
                                    to="/"
                                    className="flex-1 bg-primary hover:from-blue-700 hover:to-purple-700 text-white py-3 px-6 rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center gap-3"
                                >
                                    <FaHome className="text-sm" />
                                    Go Home
                                </Link>
                                <button
                                    onClick={() => window.history.back()}
                                    className="flex-1 bg-white/10 hover:bg-white/20 border border-white/20 text-white py-3 px-6 rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center gap-3"
                                >
                                    <FaArrowLeft className="text-sm" />
                                    Go Back
                                </button>
                            </div>

                            {/* Search Suggestion */}
                            {/* <div className="text-center">
                                <p className="text-gray-400 text-sm mb-3">
                                    Can't find what you're looking for?
                                </p>
                                <div className="relative max-w-md mx-auto">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FaSearch className="text-gray-400" />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Try searching our site..."
                                        className="w-full pl-10 pr-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                // Implement search functionality here
                                                const query = e.target.value;
                                                if (query.trim()) {
                                                    window.location.href = `/search?q=${encodeURIComponent(query)}`;
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div> */}
                        </div>
                    </div>

                    {/* Footer Links */}
                    <div className="border-t border-white/10 bg-black/20 p-6">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                                <span>OPTIM OPS CRM System</span>
                            </div>
                            {/* <div className="flex gap-6">
                                <Link to="/support" className="hover:text-white transition-colors">
                                    Support
                                </Link>
                                <Link to="/contact" className="hover:text-white transition-colors">
                                    Contact
                                </Link>
                                <Link to="/docs" className="hover:text-white transition-colors">
                                    Documentation
                                </Link>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* Quick Links */}
                {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
                    {[
                        { name: 'Dashboard', path: '/' },
                        { name: 'Help Center', path: '/help' },
                        { name: 'Contact Us', path: '/contact' },
                        { name: 'Status', path: '/status' }
                    ].map((link, index) => (
                        <Link
                            key={index}
                            to={link.path}
                            className="bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl p-4 text-center text-white transition-all duration-200 hover:scale-105 hover:shadow-lg"
                        >
                            <div className="font-medium text-sm">{link.name}</div>
                        </Link>
                    ))}
                </div> */}
            </div>
        </div>
    );
};

export default NotFound;